import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";

import { UpgradeAccount } from "../UpgradeAccount/UpgradeAccount";
import TimerSettings from "./Components/TimerSettings";
import VictorySettings from "./Components/VictorySettings";
import FailSettings from "./Components/FailSettings";
import SoundtrackAlert from "./Components/SoundtrackAlert";
import VideoBrief from "./Components/VideoBrief";
import HintIconSettings from "./Components/HintIconSettings";
import HintScreen from "./Components/HintScreen";

import SnackBar from "./SnackBar";

import {
  saveGameSettings,
  deleteGame,
  uploadAudioAssets,
  saveLiveWindowSettings,
  deleteFile,
  saveAssetsSettings,
} from "../../../redux/actions/settingsActions";
import { updateTimer } from "../../../redux/actions/timerActions";

import DeleteRoomModal from "./Modals/DeleteRoomModal";

export class GameSettings extends Component {
  state = {
    game_data: this.props.game ? this.props.game[0] : {},
    settings: this.props.game ? this.props.game[0] : {},
    timer_settings: {},
    livewindow_settings: {},
    editAudioSoundtrack: false,
    editAudioAlert: false,
    editAudioSuccess: false,
    editAudioFail: false,
    editVideoBrief: false,
    videoUploadError: "",
    lw_bg_color: "",
    editBackgroundImage: false,
    editClueIconImage: false,
    subscriptionStatus: "",
    savingLiveWindowSettings: false,
    savingBasicSettings: false,
    editBackgroundColor: false,
    trial_expired: false,
    updatePreview: false,
    activeTab: 'timer',
  };

  componentDidMount() {
    document.title = "Game Settings - Bolt";
    // this.checkSubscription();
  }

  componentDidUpdate(prevProps) {
    if (this.props.lw_settings !== prevProps.lw_settings) {
      this.setState({
        livewindow_settings: {
          ...this.state.livewindow_settings,
          ...this.props.lw_settings,
        },
      });
    }

    if (this.props.game !== prevProps.game) {
      this.setState({
        settings: { ...this.props.game },
        timer_settings: { ...this.props.game.timer },
      });
    }

    if (this.props.game_save_success !== prevProps.game_save_success) {
      this.setState({
        settings: { ...this.props.game },
        timer_settings: { ...this.props.game.timer },
      });
    }

    if (this.props.account !== prevProps.account) {
      const { account } = this.props;
    }
  }

  handleEdit = (type) => {
    if (this.props.upload_progress > 0) return;

    if (type === "soundtrack") {
      this.setState({ editAudioSoundtrack: true });
    } else if (type === "alert") {
      this.setState({ editAudioAlert: true });
    } else if (type === "success") {
      this.setState({ editAudioSuccess: true });
    } else if (type === "fail") {
      this.setState({ editAudioFail: true });
    } else if (type === "video_brief") {
      this.setState({ editVideoBrief: true });
    } else if (type === "background_image") {
      this.setState({ editBackgroundImage: true });
    } else if (type === "clue_icon_image") {
      this.setState({ editClueIconImage: true });
    }
  };

  handleChangeSettings = (e) => {
    const update = {
      [e.target.name]: e.target.value,
    };
    this.setState({
      settings: { ...this.state.settings, ...update },
    });
  };

  handleChangeLiveWindowSettings = (e) => {
    const update = {
      [e.target.name]: e.target.value,
    };
    this.setState({
      livewindow_settings: { ...this.state.livewindow_settings, ...update },
    });
  };

  handleChangeTimerSettings = (e) => {
    const newData = {
      [e.target.name]: e.target.value,
    };

    if (e.target.name === "timer") {
      const time = {
        m: String(e.target.value / 60),
        s: "00",
      };
      const timer = {
        ...this.state.timer_settings,
        seconds: e.target.value,
        time,
      };

      this.setState({
        settings: { ...this.state.settings, timer },
      });

      this.props.saveGameSettings(this.props.game.id, "timer", timer);
    } else {
      const timer = {
        ...this.state.timer_settings,
        ...newData,
      };

      this.setState({
        settings: { ...this.state.settings, timer },
      });

      this.props.saveGameSettings(this.props.game.id, this.state.settings);
    }
  };

  handleSoundtrackFile = (file) => {
    this.props.uploadAudioAssets(
      file,
      "audio_soundtrack",
      this.props.match.params.id
    );
    this.setState({ editAudioSoundtrack: false });
  };

  handleAlertFile = (file) => {
    this.setState({ editAudioAlert: false });
    this.props.uploadAudioAssets(
      file,
      "audio_alert",
      this.props.match.params.id
    );
  };

  handleSuccessFile = (file) => {
    this.props.uploadAudioAssets(
      file,
      "audio_success",
      this.props.match.params.id
    );
    this.setState({ editAudioSuccess: false });
  };

  handleFailFile = (file) => {
    this.props.uploadAudioAssets(
      file,
      "audio_fail",
      this.props.match.params.id
    );
    this.setState({ editAudioFail: false });
  };

  handleVideoFile = (file) => {
    if (file.size > 100000000) {
      this.setState({ videoUploadError: "File size too large." });
    } else {
      this.props.uploadAudioAssets(
        file,
        "video_brief",
        this.props.match.params.id
      );
      this.setState({
        editVideoBrief: false,
        videoUploadError: "",
      });
    }
  };

  handleUploadFile = (file, type, id) => {
    this.props.uploadAudioAssets(file, type, this.props.match.params.id, id);

    if (type === "video_brief") this.setState({ editVideoBrief: false });
    if (type === "audio_fail") this.setState({ editAudioFail: false });
    if (type === "audio_success") this.setState({ editAudioSuccess: false });
    if (type === "audio_soundtrack")
      this.setState({ editAudioSoundtrack: false });
    if (type === "clue_icon_image") this.setState({ editClueIconImage: false });
    if (type === "background_image")
      this.setState({ editBackgroundImage: false });
  };

  handleDeleteFile = (type, file) => {
    console.log('file', file)
    this.props.deleteFile(this.props.match.params.id, type, file);

    if (type === "video_brief") this.setState({ editVideoBrief: true });
    if (type === "audio_fail") this.setState({ editAudioFail: true });
    if (type === "audio_success") this.setState({ editAudioSuccess: true });
    if (type === "audio_soundtrack")
      this.setState({ editAudioSoundtrack: true });
    if (type === "clue_icon_image") this.setState({ editClueIconImage: true });
    if (type === "background_image")
      this.setState({ editBackgroundImage: true });
  };

  handleBackgroundColor = (color) => {
    this.setState({
      livewindow_settings: {
        ...this.state.livewindow_settings,
        background_color: color.hex,
      },
    });
  };

  // async isSubscribed() {
  //   let promise = new Promise((resolve, reject) => {
  //     const { trial_expired } = this.state;
  //     const user_account = this.props.account;
  //     const status = user_account.subscription.status;
  //     const product_id = user_account.subscription.product_id;
  //     const pro_plan = "prod_IIlkUib4nS3RBH";
  //     const basic_plan = "prod_IIkAc15oZKrJPG";

  //     if (!status && !trial_expired) resolve("Trial");
  //     if (!status && trial_expired) resolve("Not Subscribed")
  //     if (status === "active" && product_id === pro_plan) resolve("Pro");
  //     if (status === "active" && product_id === basic_plan) resolve("Basic");
  //     if (status === "cancelled" || !status) resolve("Not Subscribed");
  //   });

  //   let result = await promise;
  //   return result;
  // }

  // checkSubscription() {
  //   return this.isSubscribed().then((x) => {
  //     this.setState({ subscriptionStatus: x });
  //   });
  // }

  handleSaveLiveWindowSettings() {
    this.setState({
      savingLiveWindowSettings: true,
    });
    this.props.saveLiveWindowSettings(
      this.props.game.id,
      this.state.livewindow_settings
    );
  }

  updatePreview = () => {
    this.setState({ updatePreview: !this.updatePreview });
  };

  deleteGame = (id) => {
    this.props.deleteGame(id);
    this.props.history.push("/");
  };

  handleTabChange = (tabName) => {
    console.log('Switching to tab:', tabName);
    this.setState({ activeTab: tabName }, () => {
      console.log('Current active tab:', this.state.activeTab);
    });
  };

  render() {
    const {
      game,
      assets,
      upload_progress,
      editVideoBrief,
      lw_settings,
      account,
    } = this.props;
    const {
      editAudioSoundtrack,
      editAudioAlert,
      editAudioFail,
      editAudioSuccess,
      editBackgroundImage,
      editClueIconImage,
      videoUploadError,
      subscriptionStatus,
      livewindow_settings,
      editBackgroundColor,
      trial_expired,
    } = this.state;

    console.log('Rendering with active tab:', this.state.activeTab);

    return (
      <div className={`min-h-screen bg-gray-50 ${this.props.settings.game_save_success === "saving" || this.props.settings.livewindow_save_success === "saving" ? "opacity-50 pointer-events-none" : ""}`}>
        <SnackBar
          message="Successfully Saved"
          game_save_success={this.props.game_save_success}
          livewindow_save_success={this.props.settings.livewindow_save_success}
        />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {!game ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600"></div>
            </div>
          ) : (
            <div className="space-y-8">
              {/* Header */}
              <div className="flex items-center justify-between">
                <a href="/" className="inline-flex items-center text-gray-600 hover:text-gray-900">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  Back to Dashboard
                </a>
                <h1 className="text-3xl font-bold text-gray-900">{game.name}</h1>
              </div>

              {/* Main Content */}
              <div className="bg-white shadow rounded-lg">
                {/* Room Settings Section */}
                <div className="px-6 py-5 border-b border-gray-200">
                  <h2 className="text-xl font-semibold text-gray-900 mb-6">Room Settings</h2>
                  <form className="space-y-6">
                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                      <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                          Room Name*
                        </label>
                        <input
                          type="text"
                          name="name" 
                          id="name"
                          onChange={this.handleChangeSettings}
                          value={this.state.settings?.name || ''}
                          className="mt-1 block w-full px-3 py-2 rounded-md border border-gray-300 
                                   shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 
                                   placeholder-gray-400 text-gray-900 sm:text-sm"
                          placeholder="Enter room name"
                        />
                      </div>
                      <div>
                        <label htmlFor="timer" className="block text-sm font-medium text-gray-700">
                          Default Time Limit*
                        </label>
                        <select
                          id="timer"
                          name="timer"
                          onChange={(e) => this.handleChangeTimerSettings(e)}
                          value={this.state.timer_settings ? this.state.timer_settings.seconds : ""}
                          className="mt-1 block w-full px-3 py-2 rounded-md border border-gray-300 
                                   shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 
                                   placeholder-gray-400 text-gray-900 sm:text-sm"
                        >
                          <option value="7200">120 min</option>
                          <option value="5400">90 min</option>
                          <option value="4500">75 min</option>
                          <option value="4200">70 min</option>
                          <option value="3600">60 min</option>
                          <option value="3300">55 min</option>
                          <option value="3000">50 min</option>
                          <option value="2700">45 min</option>
                          <option value="2100">35 min</option>
                          <option value="1800">30 min</option>
                          <option value="1500">25 min</option>
                          <option value="1200">20 min</option>
                          <option value="900">15 min</option>
                          <option value="600">10 min</option>
                          <option value="300">5 min</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button
                        onClick={() => this.props.saveGameSettings(game.id, "name", this.state.settings)}
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      >
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>

                {/* Player Screen Appearance Section */}
                <div className="px-6 py-5">
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">Player Screen Appearance</h2>
                  <p className="text-sm text-gray-500 mb-6">Customize the look and feel of the player screen.</p>

                  {/* Tabs */}
                  <div style={{ display: "flex" }}>
                    <ul
                      className="nav nav-line"
                      style={{ margin: "0 auto" }}
                      id="screen-tabs"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          id="timer"
                          data-toggle="tab"
                          href="#timer-tab"
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                        >
                          Timer View
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          id="hint"
                          data-toggle="tab"
                          href="#hint-tab"
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                        >
                          Clue View
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          id="victory"
                          data-toggle="tab"
                          href="#victory-tab"
                          role="tab"
                          aria-controls="home"
                          aria-selected="false"
                        >
                          Room Win View
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          id="fail"
                          data-toggle="tab"
                          href="#fail-tab"
                          role="tab"
                          aria-controls="profile"
                          aria-selected="false"
                        >
                          Room Loss View
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* Tab Content */}
                  <div className="tab-content">
                    <div
                      className="tab-pane fade active show"
                      id="timer-tab"
                      role="tabpanel"
                      aria-labelledby="home-tab5"
                    >
                      <TimerSettings
                        game_id={game.id}
                        game_data={game}
                        game_assets={assets}
                        lw_settings={lw_settings}
                        saveGameSettings={this.props.saveGameSettings}
                        saveLiveWindowSettings={this.props.saveLiveWindowSettings}
                        handleDeleteFile={this.handleDeleteFile}
                        handleUploadFile={this.handleUploadFile}
                        handleVideoFile={this.handleVideoFile}
                        updatePreview={this.updatePreview}
                        upload_progress={upload_progress}
                      />
                    </div>

                    <div
                      className="tab-pane fade"
                      id="hint-tab"
                      role="tabpanel"
                      aria-labelledby="home-tab5"
                    >
                      {lw_settings && (
                        <HintScreen
                          game_id={game.id}
                          lw_settings={lw_settings}
                          saveLiveWindowSettings={this.props.saveLiveWindowSettings}
                          updatePreviewState={this.state.updatePreview}
                          game_assets={assets}
                        />
                      )}
                    </div>

                    <div
                      className="tab-pane fade"
                      id="victory-tab"
                      role="tabpanel"
                      aria-labelledby="home-tab5"
                    >
                      {lw_settings && (
                        <VictorySettings
                          game_id={game.id}
                          game_data={lw_settings}
                          assets={assets}
                          editAudioSuccess={editAudioSuccess}
                          saveLiveWindowSettings={this.props.saveLiveWindowSettings}
                          saveAssetsSettings={this.props.saveAssetsSettings}
                          handleEdit={this.handleEdit}
                          handleDeleteFile={this.handleDeleteFile}
                          handleSuccessFile={this.handleSuccessFile}
                          handleUploadFile={this.handleUploadFile}
                          upload_progress={upload_progress}
                        />
                      )}
                    </div>

                    <div
                      className="tab-pane fade"
                      id="fail-tab"
                      role="tabpanel"
                      aria-labelledby="profile-tab5"
                    >
                      {lw_settings && (
                        <FailSettings
                          game_id={game.id}
                          game_data={lw_settings}
                          assets={assets}
                          editAudioFail={editAudioFail}
                          saveLiveWindowSettings={this.props.saveLiveWindowSettings}
                          saveAssetsSettings={this.props.saveAssetsSettings}
                          handleEdit={this.handleEdit}
                          handleDeleteFile={this.handleDeleteFile}
                          handleFailFile={this.handleFailFile}
                          handleUploadFile={this.handleUploadFile}
                          upload_progress={upload_progress}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Additional Settings Sections */}
                <div className="px-6 py-5 border-t border-gray-200">
                  {lw_settings && (
                    <HintIconSettings
                      game_id={game.id}
                      saveLiveWindowSettings={this.props.saveLiveWindowSettings}
                      lw_settings={lw_settings}
                      account={account}
                      upload_progress={upload_progress}
                      handleUploadFile={this.handleUploadFile}
                      handleDeleteFile={this.handleDeleteFile}
                      game_assets={assets}
                    />
                  )}
                </div>

                <div className="px-6 py-5 border-t border-gray-200">
                  <VideoBrief
                    game_id={game.id}
                    account={account}
                    upload_progress={upload_progress}
                    handleUploadFile={this.handleUploadFile}
                    handleDeleteFile={this.handleDeleteFile}
                    assets={assets}
                  />
                </div>

                <div className="px-6 py-5 border-t border-gray-200">
                  <SoundtrackAlert
                    game_id={game.id}
                    game_data={lw_settings}
                    assets={assets}
                    editAudioSoundtrack={editAudioSoundtrack}
                    editAudioAlert={editAudioAlert}
                    saveAssetsSettings={this.props.saveAssetsSettings}
                    handleEdit={this.handleEdit}
                    handleDeleteFile={this.handleDeleteFile}
                    handleSoundtrackFile={this.handleSoundtrackFile}
                    handleAlertFile={this.handleAlertFile}
                    handleUploadFile={this.handleUploadFile}
                    account={account}
                    upload_progress={upload_progress}
                  />
                </div>

                {/* Delete Game Section */}
                <div className="px-6 py-5 border-t border-gray-200 bg-red-50">
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">Delete Game</h2>
                  <p className="text-sm text-gray-600 mb-4">
                    By deleting this game, you will lose access to all data associated with <span className="font-semibold">{game.name}</span>. This action cannot be undone.
                  </p>
                  <button
                    onClick={() => document.getElementById('deleteRoomModal').click()}
                    type="button"
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                  >
                    Delete {game.name}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <DeleteRoomModal game={game} deleteGame={this.deleteGame} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const account_id = state.firebase.profile.account_id
    ? state.firebase.profile.account_id
    : null;

  return {
    game: state.firestore.ordered.gamemaster
      ? state.firestore.ordered.gamemaster[0]
      : null,
    settings: state.settings,
    uid: state.firebase.auth.uid ? state.firebase.auth.uid : "123",
    profile: state.firebase.profile,
    account: state.firestore.ordered.user_accounts
      ? state.firestore.ordered.user_accounts[0]
      : null,
    account_id: account_id,
    assets: state.firestore.data.assets ? state.firestore.data.assets : null,
    upload_progress: state.settings.upload_audio_progress,
    lw_settings: state.firestore.ordered.livewindow_settings
      ? state.firestore.ordered.livewindow_settings[0]
      : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveGameSettings: (game_doc, type, settings) =>
      dispatch(saveGameSettings(game_doc, type, settings)),
    saveLiveWindowSettings: (game_doc, settings) =>
      dispatch(saveLiveWindowSettings(game_doc, settings)),
    deleteGame: (game_doc) => dispatch(deleteGame(game_doc)),
    uploadAudioAssets: (file, type, game_doc, id) =>
      dispatch(uploadAudioAssets(file, type, game_doc, id)),
    deleteFile: (game_doc, type, file) => dispatch(deleteFile(game_doc, type, file)),
    saveAssetsSettings: (game_doc, type, settings) =>
      dispatch(saveAssetsSettings(game_doc, type, settings)),
    updateTimer: (data) => dispatch(updateTimer(data)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "gamemaster",
      doc: props.match.params.id,
    },
    {
      collection: "gamemaster",
      doc: props.match.params.id,
      subcollections: [
        {
          collection: "assets",
        },
      ],
      storeAs: "assets",
    },
    {
      collection: "gamemaster",
      doc: props.match.params.id,
      subcollections: [
        {
          collection: "settings",
          doc: "live_window",
        },
      ],
      storeAs: "livewindow_settings",
    },
    {
      collection: "user_accounts",
      doc: props.account_id,
    },
  ])
)(GameSettings);
